import type { CheckboxProps } from "@mui/material/Checkbox";
import Checkbox from "@mui/material/Checkbox";
import type { FormControlLabelProps } from "@mui/material/FormControlLabel";
import FormControlLabel from "@mui/material/FormControlLabel";

type CheckboxFieldProps = CheckboxProps &
  Omit<FormControlLabelProps, "control">;

const CheckboxField = ({
  label,
  labelPlacement,
  ...props
}: CheckboxFieldProps) => (
  <FormControlLabel
    control={<Checkbox {...props} />}
    label={label}
    labelPlacement={labelPlacement}
  />
);

export default CheckboxField;
